import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

class RouterComponent extends Component {

  render() {

    return (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  }


};

const mapStateToProps = ({ auth }) => {
  const { token, user } = auth;
  return { token, user }
}
export default connect(mapStateToProps, {})(RouterComponent);



// WEBPACK FOOTER //
// ./src/Router.js